/* eslint-disable react/prop-types */
import React, { Suspense } from 'react'
import { useSelector } from 'react-redux'
import { HashRouter, Route, Routes, Navigate } from 'react-router-dom'
import { CSpinner } from '@coreui/react'
import './scss/style.scss'
import { MsalProvider } from '@azure/msal-react'
// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/azureLogin/AzureLogin'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

const App = ({ msalInstance }) => {
  const { loading } = useSelector((state) => state.bootstrap)

  // const isAuthenticated = data?.auth
  const isAuthenticated = sessionStorage.getItem('syngentaAdminToken')

  if (loading)
    return (
      <div
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}
      >
        <CSpinner variant="grow" />
      </div>
    )

  return (
    <MsalProvider instance={msalInstance}>
      <HashRouter>
        <Suspense fallback={loading}>
          <Routes>
            <Route
              exact
              path="/login"
              name="Login Page"
              element={
                isAuthenticated ? <Navigate to="/loyalty-members/points-adjustment" /> : <Login />
              }
            />
            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route exact path="/500" name="Page 500" element={<Page500 />} />
            <Route
              path="*"
              name="Home"
              element={isAuthenticated ? <DefaultLayout /> : <Navigate to="/login" />}
            />
          </Routes>
        </Suspense>
      </HashRouter>
    </MsalProvider>
  )
}

export default App
